import {getQualifications} from '../api/qualification';

import {getErrors} from '../utils/tools';

export function getQualificationsAction() {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return getQualifications(token)
        .then(res => {
          dispatch({
              type:"UPDATE_QUALIFICATIONS",
              listOfQualifications:res
          });
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/qualification.js